export enum ETransmittalBulkUploadJsonKey {
  DESCRIPTION = 'Description',
  DOC_NO = 'Document Number',
  REV_NO = 'Revision Number',
  FILE_NAME = 'Upload File Name',
}

export const BULK_UPLOAD_XLSX_FILENAME = 'BulkUploadList';
export const BULK_UPLOAD_XLSX_FILETYPE = 'xlsx';
